import { useEffect } from "react";

export default function AlertMessage({ type = "success", message, onClose }) {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => onClose(), 3000);
    return () => clearTimeout(timer);
  }, [message]);

  if (!message) return null;

  return (
    <div
      className={`alert alert-${type} position-fixed`}
      style={{ top: "20px", right: "20px", zIndex: 3000 }}
      role="alert"
    >
      {message}
    </div>
  );
}
